exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topDiv {\n  padding-top: 59px;\n  background: whitesmoke;\n  height: 100vh; }\n\n.rowStyle {\n  height: 84vh; }\n\n#deviceTable input {\n  border-radius: 5px; }\n\n::-webkit-scrollbar {\n  width: 10px; }\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #999999; }\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #868e96; }\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/product-summary/add-product/add-product.component.scss
// module id = ../../../../../src/app/product-summary/add-product/add-product.component.scss
// module chunks = main